<template lang="pug">
    .categorypage
        .section.header(v-if="headerSections.length" v-for="(section, index) in headerSections" :key="section.id" :class="section.key")
            Banner(v-if="section.key === 'banner'" :section="section")
            Slider(v-if="section.key === 'slider'" :section="section")
        .section.body(v-if="mainSections.length" v-for="(section, index) in mainSections" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            CategoryPosts(v-if="section.key === 'categoryposts'" :section="section")
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Post from '@/components/Post'
import Slider from '@/components/Slider'
import CategoryPosts from '@/components/CategoryPosts'
import Banner from '@/components/Banner'

export default {
    name: 'CategoryPage',
    components: {
        Heading,
        ImageSection,
        Post,
        Slider,
        CategoryPosts,
        Banner,
    },
    computed: {
        headerSections() {
            return this.filteredSections.filter(section => section.area === 'header')
        },
        mainSections() {
            return this.filteredSections.filter(section => section.area === 'main')
        },
        filteredSections() {
            return this.sections.filter(section => {
                return section.key === 'heading'
                    || section.key === 'image'
                    || section.key === 'post'
                    || section.key === 'slider'
                    || section.key === 'banner'
                    || section.key === 'categoryposts'
            })
        },
        ...mapGetters({
            sections: 'currentPage/sections',
        })
    }
}

</script>

<style lang="sass" scoped>
    // .categorypage
    //     & > .section
    //         padding-bottom: 0
    //         &:first-child
    //             padding-top: 4.5rem
    //         &:last-child
    //             padding-bottom: 4.5rem
    //         &.category-page-teaser
    //             display: none
    .section.slider,
    .section.banner
        padding: 0
    .section.heading
        text-transform: initial
</style>
